import { render, staticRenderFns } from "./MySurveys.vue?vue&type=template&id=6b3f5a2a&"
import script from "./MySurveys.vue?vue&type=script&lang=js&"
export * from "./MySurveys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports